import { Goal } from '@/app/entities/Team'
import { httpClient } from '../http/httpClient'

export interface CommissionValue {
  value: number
  seller?: number
  leader?: number
  supervisor?: number
}

export interface Commission {
  table: string
  type?: string
  seller?: number
  leader?: number
  supervisor?: number
  values?: CommissionValue[]
}

export interface UpdateTeamdata {
  name?: string
  about?: string
  manager_id?: string | null
  supervisor_id?: string | null
  leader_id?: string | null
  commission_rate?: number
  goal?: Goal[]
  goals?: {
    [key: string]: Goal[]
  }
  commission?: {
    after_goal: number
    before_goal: number
  }
  commissionV2?: Commission[]
}

export interface UpdateTeamResponse {
  _id: string
  name: string
  about: string
  manager_id: string | null
  supervisor_id: string | null
  leader_id: string | null
  comission_rate: number
  members: string[]
  commissionV2: Commission[]
}

export const updateTeam = async (updateData: UpdateTeamdata, id: string) => {
  const { data } = await httpClient
    .put<UpdateTeamResponse>(`team/${id}`, updateData)
    .catch((err) => {
      throw err?.response?.data || err?.response || err
    })

  return data
}
